/**
 * PHP-injected origin for this host's REST (login-auth / connectUser).
 *
 * When PHP embeds a React dist it sets `window._msApiEndpoint` to
 * `location.origin` so login-auth talks to the same host that issued
 * `_msAuth.userPool`. php-client must NOT use this — see
 * `resolvePhpClientEndpoint`.
 *
 * Hosted Amplify / `pnpm dev` never set `_msApiEndpoint`; callers keep the
 * configured Vite base (`/api` or the Dev/prod URL).
 */
export function resolvePhpApiEndpoint(configuredBase: string): string {
  return globalThis.window?._msApiEndpoint || configuredBase;
}
